/**
 * Content with no server behind it yet (PLAN.md §5). Edit here; later these move to admin-editable tables.
 */

/** Sticky note: one quote per day. SAMPLE lines from the design - replace with Caryn's own before real use. */
export const QUOTES = [
  'Rain on the window, tea in my hands, and you on my mind.',
  'Be soft. Stay curious. Keep a little mystery.',
  'Some days are for hiking. Some days are for hiding. Both count.',
  'Wear the good perfume on a Tuesday.',
  'Golden hour makes everyone a little braver.',
  'I save my best stories for the people who listen.',
]
export function quoteOfTheDay(d = new Date()) {
  const day = Math.floor((d.getTime() - new Date(d.getFullYear(), 0, 0).getTime()) / 864e5)
  return QUOTES[day % QUOTES.length]
}

export interface DiaryPost { date: string; mood: string; title: string; text: string[]; photo?: string; alt?: string; gallery?: boolean }

/**
 * Email + Diary content now come from Caryn's server (messaging-service config/fanMail.js; GET /api/messages/fan-mail,
 * GET /api/messages/diary). These copies are the SAME words, used only if the server has not been updated yet, and by
 * the demo server. Change the words in the backend file first, then here.
 */
export const WELCOME_MAIL = {
  id: 'welcome', from: 'Caryn Marjorie', subject: 'Welcome to your new email', preview: 'This is where I will be sending you things that you should know about…',
  body: ['Hey {name},', 'This is where I will be sending you things that you should know about. Each email self destructs within 24 hours of you opening it.', 'I can’t wait to send you some fun stuff here.'],
  links: [] as [string, string][], // owner 11-04: no Say hi / See the gallery buttons for now
  deleteHoursAfterOpen: 24,
  sentAt: '2026-11-04T17:00:00.000Z', // owner 11-04: the welcome email is dated Nov 4
}
export const DIARY_FALLBACK: DiaryPost[] = [
  { date: 'Nov 4', mood: 'Happy', title: 'Welcome to my diary',
    text: ['This is where I’ll write the little things I don’t post anywhere else: trips, thoughts, and the stories behind the photos.', 'Thank you for being here with me.'] },
]


/** Seasonal decoration (decorative only; hidden with reduced motion by the design CSS). */
export const SEASONS = {
  autumn: ['s-leaf', 's-spark', 's-pumpkin'],
  winter: ['s-flake', 's-spark', 'i-heart'],
  spring: ['s-flower', 's-spark', 's-leaf'],
  summer: ['s-sun', 's-spark', 's-flower'],
} as const
export function seasonIcons(d = new Date()) {
  const q = new URLSearchParams(location.search).get('season') as keyof typeof SEASONS | null
  const byMonth = (['winter', 'winter', 'spring', 'spring', 'spring', 'summer', 'summer', 'summer', 'autumn', 'autumn', 'autumn', 'winter'] as const)[d.getMonth()]
  return SEASONS[q && q in SEASONS ? q : byMonth]
}
